import React, { useState } from 'react';



const Win95Section = ({ title, children }) => (
  <div className="mb-6 border-2 border-gray-400">
    <div className="bg-[#000080] text-white px-2 py-1 font-bold flex items-center">
      <span className="mr-2">■■</span>
      {title}
    </div>
    <div className="p-4 bg-[#c0c0c0]">{children}</div>
  </div>
);
const FullScreenImage = ({ imageUrl, onClose }) => {
  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-90 z-[100] flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="relative max-w-full max-h-full">
        <button 
          onClick={onClose}
          className="absolute top-2 right-2 bg-white text-black px-3 py-1 rounded-full z-50"
        >
          X
        </button>
        <img 
          src={imageUrl} 
          alt="Full screen" 
          className="max-w-full max-h-full object-contain" 
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    </div>
  );
};

const ProjectModal = ({ project, onClose }) => {

  if (!project) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-[#c0c0c0] border-t-2 border-l-2 border-white border-b-2 border-r-2 border-gray-600 max-w-2xl w-full">
        <div className="bg-[#000080] text-white p-2 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <img src={project.logo} alt="" className="w-6 h-6" />
            <span className="font-bold">{project.title}</span>
          </div>
          <button 
            onClick={onClose}
            className="bg-[#c0c0c0] text-black px-2 border-t border-l border-white border-b border-r border-gray-600"
          >
            X
          </button>
        </div>
        <div className="p-4 space-y-4">
          <div className="bg-white p-4 border border-gray-400">
            <p>{project.description}</p>
            <div className="mt-4">
              <h4 className="font-bold">Roles:</h4>
              <ul className="list-disc ml-6">
                {project.roles.map((role, i) => (
                  <li key={i}>{role}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {project.media.map((item, i) => (
              <div key={i} className="bg-white p-2 border border-gray-400">
                {item.type === 'image' ? (
                  <img src={item.url} alt={item.caption} className="w-full h-48 object-cover" />
                ) : (
                  <video src={item.url} controls className="w-full h-48 object-cover" />
                )}
                <p className="mt-2 text-sm text-center">{item.caption}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

};

const ResumePage = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
    {
      id: 1,
      title: "4FingerStudios",
      logo: "https://cdn.4fingerstudios.com/assets/images/TPBG_4FSLogoSocials.png", // Replace with actual logo path
      logo: "https://cdn.4fingerstudios.com/assets/images/4black.png", // Replace with actual logo path
      description: "Welcome To The Studio! This is the studio I founded when i was a young lad with my buds.",
      quote: "A Place Where People Can Let Go Of Restrictions And Be Them Selfs",
      roles: [
        "FOUNDER",
      ],
      media: [
        { 
          type: 'image', 
          url: "https://cdn.4fingerstudios.com/assets/images/PH.png", 
          caption: "Coming Soon!" 
        },
       // { 
        //  type: 'video', 
        //  url: "/path/to/project-demo.mp4", 
        //  caption: "Project Alpha - Gameplay Demo" 
      //  }
      ]
    },
  {
      id: 2,
      title: "Playtime Plus",
      logo: "https://cdn.4fingerstudios.com/assets/images/Playtime_Plus_Logo_Flat.png", // Replace with actual logo path
      description: "It was a love letter passion project with the intent of reimagining Project playtime as a game with more potential, Adding New Monsters, old and new customizations, New monthly maps .",
      quote: "Now cancled, but could have been A passion project reimagining a games potential",
      roles: [
        "Lead Developer",
        "Level Designer",
        "Ideas",
        "Scouting",
      ],

      media: [

        { 

          type: 'image', 

          url: "https://cdn.4fingerstudios.com/assets/images/PH.png", 

          caption: "Coming Soon!" 

        },

       // { 

        //  type: 'video', 

        //  url: "/path/to/project-demo.mp4", 

        //  caption: "Project Alpha - Gameplay Demo" 

      //  }

      ]

    },
    {
      id: 3,
      title: "Fishers HighSchool Projects",
      logo: "https://image.maxpreps.io/school-mascot/9/5/1/951860ab-d82d-476e-b355-80a8dbad705e.gif?version=637304818800000000&width=1024&height=1024", // Replace with actual logo path
      description: "All of My School Video Projects Good And Bad",
      quote: "Have pride, show character, build tradition",
      roles: [
        "Student",
      ],
      media: [
        { 
          type: 'Video', 
          url: "N/A", 
          caption: "Coming Soon!" 
        },
       // { 
        //  type: 'video', 
        //  url: "/path/to/project-demo.mp4", 
        //  caption: "Project Alpha - Gameplay Demo" 
      //  }
      ]
    },
    {

        id: 4,
        title: "Unity Works",
        logo: "https://cdn.4fingerstudios.com/assets/images/eye.png", // Replace with actual logo path
        description: "My Unity Works From Vrchat Mainly",
        quote: "I had no Team",
        roles: [
          "Simple coding",
        ],

        media: [

          { 
            type: 'image', 
            url: "https://api.vrchat.cloud/api/1/file/file_72116e90-08a6-4027-ba6f-62e2b21a050b/1/file", 
            caption: "Jameskii's Fan Hangout World ≺BETA≻" 
          },
          { 
            type: 'image', 
            url: "https://api.vrchat.cloud/api/1/file/file_cb6fc4e0-6590-41c4-9807-96fe00ca11f3/1/file", 
            caption: "The Center" 
          },

          { 
            type: 'image', 
            url: "https://cdn.4fingerstudios.com/assets/images/PH.png", 
            caption: "Coming Soon!" 
          },
        ]
      },
      {

        id: 5,
        title: "Whispers Of The Forgotten",
        logo: "https://cdn.4fingerstudios.com/assets/images/WOTF.png", // Replace with actual logo path
        description: "...",
        quote: "...",
        roles: [
          "...",
        ],

        media: [

          { 
            type: 'image', 
            url: "https://cdn.4fingerstudios.com/assets/images/PH.png", 
            caption: "≺COMING SOON≻" 
          },
        ]
      },
      {

        id: 6,
        title: "Escape Protocol",
        logo: "https://cdn.4fingerstudios.com/assets/images/Escape_Protocol_Logo.png", // Replace with actual logo path
        description: "...",
        quote: "...",
        roles: [
          "...",
        ],

        media: [

          { 
            type: 'image', 
            url: "https://cdn.4fingerstudios.com/assets/images/PH.png", 
            caption: "≺COMING SOON≻" 
          },
        ]
      },
  ];

  return (

    <div className="min-h-screen bg-[#008080] p-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-[#c0c0c0] border-t-2 border-l-2 border-white border-b-2 border-r-2 border-gray-600 p-1">
          <div className="bg-[#000080] text-white p-2 flex justify-between items-center">
            <div className="flex items-center">
              <span className="mr-2">📄</span>
              <span className="font-bold">Resume - Alexander Minnick</span>
            </div>
            <div className="flex gap-2">
              <button className="bg-[#c0c0c0] text-black px-2 border-t border-l border-white border-b border-r border-gray-600">_</button>
              <button className="bg-[#c0c0c0] text-black px-2 border-t border-l border-white border-b border-r border-gray-600">□</button>
              <button className="bg-[#c0c0c0] text-black px-2 border-t border-l border-white border-b border-r border-gray-600">X</button>
            </div>
          </div>

          <div className="p-4 space-y-4">
            <div className="bg-white border border-gray-400 p-4">
              <h1 className="text-2xl font-bold mb-2">Alexander Minnick | DevSilly</h1>
              <div className="space-y-1 text-sm">
                <p>4.FINGER.STUDIOS@GMAIL.COM</p>

              </div>
            </div>

            <Win95Section title="Objective">

              <p>Aspiring game developer and programmer seeking opportunities to leverage skills in game development, coding, and digital media while pursuing further education in technology-related fields.</p>

            </Win95Section>

            <Win95Section title="Education">

              <h3 className="font-bold">Fishers High School | Class of 2026</h3>

              <ul className="list-disc ml-6 mt-2">
                <li>Major Courses: AV Advanced Production, Web and Database Development, Tech Crew</li>
                <li>Perfect Attendance (Grades 9-11)</li>
                <li>Mascoting & Mascot Assistant (Grades 9-12)</li>
              </ul>
            </Win95Section>

            <Win95Section title="Professional Experience">
              <div className="mb-4">
                <div className="flex justify-between">
                  <h3 className="font-bold">Urban Air Adventure Parks</h3>
                  <span>June 2023 - Present</span>
                </div>

                <p className="font-bold">Team Member</p>
                <ul className="list-disc ml-6">
                  <li>VR Specialist and Technology Team Member</li>
                  <li>Responsible for managing and maintaining VR equipment and guest experience</li>
                </ul>
              </div>

              <div>
                <div className="flex justify-between">
                  <h3 className="font-bold">4 Finger Studios</h3>
                  <span>February 2019 - Present</span>
                </div>
                <p className="font-bold">Founder</p>
                <ul className="list-disc ml-6">
                  <li>Lead Programmer and Level Designer for game development projects</li>
                  <li>Manage basic 3D modeling and team coordination</li>
                  <li>Oversee story development and world-building initiatives</li>
                </ul>
              </div>
            </Win95Section>

            <Win95Section title="Technical Skills">
              <div className="space-y-4">
                <div>
                  <h3 className="font-bold">Programming</h3>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {['HTML', 'CSS', 'JavaScript', 'Python', 'C++ (Learning)', 'Blueprints'].map(skill => (
                      <span key={skill} className="bg-white px-2 py-1 border border-gray-400">{skill}</span>
                    ))}
                  </div>
                </div>

                <div>
                  <h3 className="font-bold">Game Development</h3>
                  <div className="flex flex-wrap gap-2 mt-2">
                    <span className="bg-white px-2 py-1 border border-gray-400">Unity (6 Years)</span>
                    <span className="bg-white px-2 py-1 border border-gray-400">Unreal Engine (2 Years)</span>
                  </div>
                </div>

                <div>
                  <h3 className="font-bold">Software</h3>
                  <div className="mt-2">
                    <span className="bg-white px-2 py-1 border border-gray-400">Adobe Premiere Pro (7 Years)</span>
                  </div>
                </div>

                <div>
                  <h3 className="font-bold">Specialties</h3>
                  <ul className="list-disc ml-6 mt-2">
                    <li>Unreal Engine Production, Blueprints, and Level Design</li>
                    <li>Unity VRChat World Creation and UDON Coding</li>
                    <li>Digital and Physical Prop Making</li>
                    <li>Storytelling and World Crafting</li>
                  </ul>
                </div>
              </div>
            </Win95Section>

            <Win95Section title="Activities & Community Involvement">

              <ul className="list-disc ml-6">
                <li>3D Printing Club (Grades 10-11)</li>
                <li>Pin It Together Club (Grade 11)</li>
                <li>Waffle Labs Club (Grade 9)</li>
                <li>Community Clean-up Projects (Grades 9-11)</li>
              </ul>
            </Win95Section>
            <Win95Section title="Projects">
  <div className="grid grid-cols-3 gap-4">
    {projects.map((project) => (
      <button 
        key={project.id} 
        onClick={() => setSelectedProject(project)} 
        className="bg-white p-2 border border-gray-400 hover:bg-gray-100 transition-colors"
      >
        <img 
          src={project.logo} 
          alt={project.title} 
          className="w-16 h-16 mx-auto mb-2 object-contain" 
        />
        <p className="text-center font-bold">{project.title}</p>
      </button>
    ))}
  </div>
</Win95Section>
          </div>
        </div>
        <Win95Section title="More Coming Soon">
              <h3 className="font-bold">TEMP</h3>
              
            </Win95Section>
      </div>
      {selectedProject && (
        <ProjectModal 
          project={selectedProject} 
          onClose={() => setSelectedProject(null)} 
        />
      )}
    </div>
  
  
 
  );
};


export default ResumePage;